import { render } from "./GavBanner.vue?vue&type=template&id=0a1ab70b&ts=true"
import script from "./GavBanner.vue?vue&type=script&lang=ts"
export * from "./GavBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__